'use strict';

/**
 * AdminController - contrôleur principal de l'administration
 */
import appModule from '../app.module';

angular.module(appModule)
.controller('AdminController', ['$scope', '$state', 'Auth', function($scope, $state, Auth) {
  
  Auth.identity().then(function(user) {
    if (!user || !Auth.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_EDITOR'])) {
      $state.go('login');
      return;
    }
    $scope.user = user;
    var name = (user.firstName || user.login || '?');
    $scope.userInitials = name.slice(0, 2).toUpperCase();
  });
  
  // Éléments du menu d'administration
  $scope.adminMenu = [
    {
      title: 'Tableau de bord',
      icon: 'dashboard',
      state: 'admin.dashboard',
      roles: ['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_EDITOR']
    },
    {
      title: 'Jeux de données',
      icon: 'dataset',
      state: 'admin.datasets',
      roles: ['ROLE_ADMIN', 'ROLE_EDITOR']
    },
    {
      title: 'Organisations',
      icon: 'business',
      state: 'admin.organizations',
      roles: ['ROLE_ADMIN', 'ROLE_EDITOR']
    },
    {
      title: 'Utilisateurs',
      icon: 'people',
      state: 'admin.users',
      roles: ['ROLE_ADMIN']
    }
  ];
  
  // Fonction pour vérifier si l'utilisateur a accès à un élément du menu
  $scope.canAccess = function(level) {
    if (level === 'admin')  return Auth.hasAnyAuthority(['ROLE_ADMIN']);
    if (level === 'editor') return Auth.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_EDITOR', 'ROLE_MODERATOR']);
    return true;
  };
  
  // Fonction de déconnexion
  $scope.logout = function() {
    Auth.logout();
  };
}]);
